"use client";

import { Loader2 } from "lucide-react";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";

interface LoadingSpinnerDialogProps {
	open: boolean;
	title?: string;
	description?: string;
}

export function LoadingSpinnerDialog({
	open,
	title = "Adding to cart...",
	description = "Checking stock and updating your cart.",
}: LoadingSpinnerDialogProps) {
	return (
		<Dialog open={open}>
			<DialogContent
				showCloseButton={false}
				onInteractOutside={(event) => event.preventDefault()}
				onEscapeKeyDown={(event) => event.preventDefault()}
				className="sm:max-w-sm"
			>
				<DialogHeader className="items-center text-center space-y-2">
					<div className="rounded-full bg-primary/10 p-3">
						<Loader2 className="h-6 w-6 animate-spin text-primary" />
					</div>
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription>{description}</DialogDescription>
				</DialogHeader>
			</DialogContent>
		</Dialog>
	);
}
